import { FilterSection } from "../../../data-model/filterValues";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { allCmmOptions } from "./filterOptions/cmmFilterOptions";
import { allPaStatusBucketOptions } from "./filterOptions/paStatusBucketFilterOptions";
import { allPaStatusOptions } from "./filterOptions/paStatusFilterOptions";
import { allRouteViaOptions } from "./filterOptions/routeViaFilterOptions";

/**
 * Filter section ids used by the oncology submission orders table.
 */
export enum OncologySubmissionFilterKeys {
  DOW = "dumped_at",
  ROUTE_VIA = "route_via",
  PA_STATUS = "pa_status",
  PA_STATUS_BUCKET = "pa_status_bucket",
  CMM = "cmm",
}

/**
 * Builds the DOW (date of work) date-range filter section.
 *
 * @input data - Oncology submission rows (unused; shape kept for consistency)
 * @return FilterSection: DOW date filter config
 */
export const createFilterForDOW = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: OncologySubmissionFilterKeys.DOW,
    label: "DOW",
    options: [],
    type: "date",
  };
};

/**
 * Builds the Route Via multi-select filter section.
 *
 * @input data - Oncology submission rows (unused; shape kept for consistency)
 * @return FilterSection: Route Via filter config
 */
export const createFilterForRouteVia = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: OncologySubmissionFilterKeys.ROUTE_VIA,
    label: "Route Via",
    options: allRouteViaOptions,
    type: "string",
  };
};

/**
 * Builds the Response Status multi-select filter section.
 *
 * @input data - Oncology submission rows (unused; shape kept for consistency)
 * @return FilterSection: Response Status filter config
 */
export const createFilterForPaStatus = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: OncologySubmissionFilterKeys.PA_STATUS,
    label: "Response Status",
    options: allPaStatusOptions,
    type: "string",
  };
};

/**
 * Builds the Outcome Class multi-select filter section.
 *
 * @input data - Oncology submission rows (unused; shape kept for consistency)
 * @return FilterSection: Outcome Class filter config
 */
export const createFilterForPaStatusBucket = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: OncologySubmissionFilterKeys.PA_STATUS_BUCKET,
    label: "Outcome Class",
    options: allPaStatusBucketOptions,
    type: "string",
  };
};

/**
 * Builds the CMM status multi-select filter section.
 *
 * @input data - Oncology submission rows (unused; shape kept for consistency)
 * @return FilterSection: CMM filter config
 */
export const createFilterForCmm = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: OncologySubmissionFilterKeys.CMM,
    label: "CMM",
    options: allCmmOptions,
    type: "string",
  };
};


/**
 * Assembles all filter sections for the oncology submission orders table.
 *
 * @input data - Oncology submission rows used to decide whether filters are available
 * @return FilterSection[]: Filter sections for the table filter modal
 */
export const createAllFilterSections = (
  data: PharmaStpFileModel[],
): FilterSection[] => {
  if (!data || data.length === 0) {
    return [];
  }

  return [
    createFilterForDOW(data),
    createFilterForRouteVia(data),
    createFilterForPaStatus(data),
    createFilterForPaStatusBucket(data),
    createFilterForCmm(data),
  ];
};
